import styled from 'styled-components';

import { Menu as MenuComponent } from '@pearsontechnology/aero-components';

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  word-break: normal;
  width: fit-content;
  position:relative;
`;

export const MenuListItemText = styled.div`
  margin: 0 8px;
  text-wrap: nowrap;
`;

export const Spacer = styled.div`
  width: 34px;
`;

export const SubMenu = styled(MenuComponent)`
  position: absolute;
  right: 100%; 
  top: 15%;
  margin-top: 0;
  word-break: normal;
  width: fit-content;
  height: fit-content;
`;

export const MenuListItemWrapper = styled.div`
  cursor: ${(props) => props.activelyDownloadingReport ? 'no-drop': 'auto'};
`;